import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_labresult-hub-1/artifacts/td8pjg41_FACTUAL%20LOGO.png" 
                alt="Factual Medical Logo" 
                className="w-12 h-12 rounded-full object-cover bg-white"
              />
              <div>
                <span className="text-lg font-bold tracking-tight block">FACTUAL MEDICAL</span>
                <span className="text-xs text-slate-400">DIAGNOSTIC CENTRE</span>
              </div>
            </div>
            <p className="text-slate-400 text-sm max-w-md mb-6">
              Advanced medical laboratory and diagnostic services. Providing accurate, 
              reliable, and timely healthcare diagnostics you can trust.
            </p>
            <div className="flex flex-col gap-2 text-sm text-slate-400">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span>FACTUALMEDICALDIAGNOSTICCENTRE@GMAIL.COM</span>
              </div>
              <div className="flex items-start gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span>09049816536, 08025072241, 08141571388</span>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span>NO 502, AROGUN BUS STOP, MOWE/OFADA ROAD, ADJACENT MEDICPLUS HOSPITAL, OGUN STATE</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300 mb-4">
              Services
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/tests" className="text-slate-400 hover:text-white transition-colors">Lab Tests</Link></li>
              <li><Link to="/tests?category=blood" className="text-slate-400 hover:text-white transition-colors">Blood Tests</Link></li>
              <li><Link to="/tests?category=imaging" className="text-slate-400 hover:text-white transition-colors">Imaging</Link></li>
              <li><Link to="/tests?category=hormones" className="text-slate-400 hover:text-white transition-colors">Hormone Panel</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300 mb-4">
              Company
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-slate-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/careers" className="text-slate-400 hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-slate-400 hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            © {currentYear} FACTUAL MEDICAL DIAGNOSTIC CENTRE. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-slate-500 flex items-center gap-1">
              <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
              Quality Assured
            </span>
            <span className="text-xs text-slate-500">Trusted Diagnostics</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
